module.exports = __webpack_public_path__ + "static/media/Isabella_L@3x.f48e789a.jpg";